import { useCallback } from 'react';
import { Box } from '@mui/material';
import Button from '@/components/atoms/Button/Button';
import {
  StyledAgioH1,
  StyledNormalText5,
} from '@/components/StyledSharedComponents/StyledTypography';
import { StyledLink } from '@/components/Error/CommonError/CommonErrorStyled';
import { TCommonErrorProps } from '@/components/Error/CommonError/CommonError.types';

const DEFAULT_TITLE = 'Something went wrong';
const DEFAULT_DESCRIPTION = 'We couldn’t load the information you were looking for.';

export const CommonError = ({
  variant,
  redirectUrl,
  onClick,
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
}: TCommonErrorProps) => {
  const generateButton = useCallback(() => {
    if (variant === 'button') {
      return (
        <Button variant="contained" fitContentWidth onClick={onClick} sx={{ marginTop: '10px' }}>
          Try again
        </Button>
      );
    }

    if (variant === 'reload') {
      const reloadPage = () => {
        window.location.reload();
      };

      return (
        <Button variant="contained" fitContentWidth onClick={reloadPage} sx={{ marginTop: '10px' }}>
          Reload the page
        </Button>
      );
    }

    if (variant === 'link') {
      return <StyledLink to={redirectUrl}>Go to main page</StyledLink>;
    }

    return null;
  }, [variant, redirectUrl, onClick]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        p: '10px 25px',
      }}
    >
      <StyledAgioH1 color="customSecondary.neutral.100" align="center">
        {title}
      </StyledAgioH1>
      <StyledNormalText5 color="customSecondary.neutral.300" align="center">
        {description}
      </StyledNormalText5>
      {generateButton()}
    </Box>
  );
};
